import { useState, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// === IMPORT YOUR LRQA LOGO ===
import lrqaLogo from "../assets/clients/LRQA logo.jpg";

const LRQAFlashReport = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const today = new Date().toLocaleDateString("en-GB");

  const [form, setForm] = useState({
    lrqaRef: "",
    poNo: "",
    equipment: "",
    vendor: "",
    location: "",
    contact: "",
    tel: "",
    fax: "",
    inspector: "",
    inspectionDate: "",
    activities: "",
    photos: [],
  });

  const reportRef = useRef();

  const handlePhotos = (e) => {
    const files = Array.from(e.target.files);
    const readers = files.map(
      (file) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (ev) => resolve(ev.target.result);
          reader.readAsDataURL(file);
        })
    );

    Promise.all(readers).then((images) => {
      setForm((prev) => ({ ...prev, photos: images }));
    });
  };

  const downloadPDF = async () => {
    const input = reportRef.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = 210;
    const pdfHeight = (canvas.height * 210) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("LRQA_Flash_Report.pdf");
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (email === "qnexservices@gmail.com" && password === "Qnexa@123") {
      setLoggedIn(true);
      setError("");
    } else {
      setError("Invalid Credentials");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      {!loggedIn ? (
        <div style={{ maxWidth: "350px", margin: "0 auto" }}>
          <h2>Login to Continue</h2>

          <form onSubmit={handleLogin}>
            <label>Email</label>
            <input
              type="email"
              style={{ width: "100%", padding: 8, marginBottom: 10 }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label>Password</label>
            <input
              type="password"
              style={{ width: "100%", padding: 8, marginBottom: 10 }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            {error && <p style={{ color: "red" }}>{error}</p>}

            <button
              type="submit"
              style={{
                width: "100%",
                padding: 10,
                background: "#007bff",
                color: "#fff",
                border: "none",
                cursor: "pointer",
              }}
            >
              Login
            </button>
          </form>
        </div>
      ) : (
        <>
          <h2>LRQA Flash Report – Input Form</h2>

          <div style={{ display: "grid", gap: 10, maxWidth: 600 }}>
            {Object.keys(form)
              .filter((k) => k !== "photos")
              .map((key) => (
                <div key={key}>
                  <label style={{ textTransform: "capitalize" }}>
                    {key.replace(/([A-Z])/g, " $1")}
                  </label>
                  <input
                    type={key.includes("Date") ? "date" : "text"}
                    value={form[key]}
                    onChange={(e) =>
                      setForm((prev) => ({ ...prev, [key]: e.target.value }))
                    }
                    style={{ width: "100%", padding: 8 }}
                  />
                </div>
              ))}

            <div>
              <label>Upload Photographs</label>
              <input type="file" multiple accept="image/*" onChange={handlePhotos} />
            </div>
          </div>

          <button
            onClick={downloadPDF}
            style={{
              marginTop: 20,
              padding: 10,
              background: "green",
              color: "white",
              border: "none",
              cursor: "pointer",
            }}
          >
            Download PDF (Exact Word Layout)
          </button>

          <h2 style={{ marginTop: 40 }}>Preview (Exact Word Table Format)</h2>

          {/* ======== FLASH REPORT PREVIEW EXACT LIKE WORD ======== */}
          <div
            ref={reportRef}
            style={{
              width: "210mm",
              minHeight: "297mm",
              background: "white",
              padding: "20mm",
              margin: "auto",
              boxShadow: "0 0 3px rgba(0,0,0,0.2)",
              fontFamily: "Arial",
              fontSize: "14px",
            }}
          >
            {/* =================== LRQA LOGO =================== */}
            <div style={{ textAlign: "center", marginBottom: 10 }}>
              <img
                src={lrqaLogo}
                alt="LRQA Logo"
                style={{
                  width: 120,
                  marginBottom: 5,
                }}
              />
            </div>

            <h2 style={{ textAlign: "center", marginBottom: 0 }}>
              INSPECTION REPORT
            </h2>
            <h3 style={{ textAlign: "center", marginTop: 0 }}>Flash Report</h3>

            {/* DATE */}
            <p>
              <strong>DATE:</strong> {today}
            </p>

            {/* TABLE EXACT LIKE WORD */}
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "10px",
              }}
              border="1"
            >
              <tbody>
                <tr>
                  <td style={{ width: "40%", padding: 8 }}>
                    <strong>LRQA REFERENCE NUMBER</strong>
                  </td>
                  <td style={{ padding: 8 }}>{form.lrqaRef}</td>
                </tr>

                <tr>
                  <td style={{ padding: 8 }}>
                    <strong>PURCHASE ORDER NO</strong>
                  </td>
                  <td style={{ padding: 8 }}>{form.poNo}</td>
                </tr>

                <tr>
                  <td style={{ padding: 8 }}>
                    <strong>EQUIPMENT</strong>
                  </td>
                  <td style={{ padding: 8 }}>{form.equipment}</td>
                </tr>

                <tr>
                  <td style={{ padding: 8 }}>
                    <strong>SUPPLIER/VENDOR</strong>
                  </td>
                  <td style={{ padding: 8 }}>{form.vendor}</td>
                </tr>

                <tr>
                  <td style={{ padding: 8 }}>
                    <strong>LOCATION</strong>
                  </td>
                  <td style={{ padding: 8 }}>{form.location}</td>
                </tr>

                <tr>
                  <td style={{ padding: 8 }}>
                    <strong>SUPPLIER’S CONTACT</strong>
                  </td>
                  <td style={{ padding: 8 }}>{form.contact}</td>
                </tr>

                <tr>
                  <td style={{ padding: 8 }}>
                    <strong>TEL NO</strong>
                  </td>
                  <td style={{ padding: 8 }}>{form.tel}</td>
                </tr>

                <tr>
                  <td style={{ padding: 8 }}>
                    <strong>FAX NO</strong>
                  </td>
                  <td style={{ padding: 8 }}>{form.fax}</td>
                </tr>
              </tbody>
            </table>

            <p style={{ marginTop: 20 }}>
              <strong>Inspector:</strong> {form.inspector}
            </p>
            <p>
              <strong>Inspection date:</strong> {form.inspectionDate}
            </p>

            <p>
              <strong>1. Inspection Activities and Results:</strong>
            </p>
            <div style={{ whiteSpace: "pre-wrap", minHeight: "60px" }}>
              {form.activities}
            </div>

            <p style={{ marginTop: 20 }}>
              <strong>Photographs:</strong>
            </p>
            {form.photos.map((img, i) => (
              <img
                key={i}
                src={img}
                style={{
                  width: "100%",
                  marginBottom: 10,
                  border: "1px solid #ccc",
                }}
              />
            ))}

            <p style={{ marginTop: 30 }}>----End of Report----</p>

            <p style={{ fontSize: 12, marginTop: 30, textAlign: "justify" }}>
              LRQA Group Limited, its affiliates and subsidiaries and their respective officers, employees…
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default LRQAFlashReport;
